module.exports = __webpack_public_path__ + "img/sleeve_ruffle_length.cf2604ea.png";